import { CommonModule, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  inject,
  input,
  model,
  signal,
  TemplateRef,
} from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { PanelMenuModule } from 'primeng/panelmenu';

@Component({
  selector: 'ui-sidebar-layout',
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    DrawerModule,
    MenubarModule,
    MenuModule,
    PanelMenuModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    BreadcrumbModule,
    NgTemplateOutlet,
    // ActionButtonComponent,
  ],
  templateUrl: './sidebar-layout.component.html',
  styleUrl: './sidebar-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarLayoutComponent {
  #router = inject(Router);

  topBarItems: MenuItem[] = [
    {
      label: 'Einstellungen',
      icon: 'fa-regular fa-gear',
      action: { type: 'OPEN_SETTINGS' },
      command: (e) => console.log('open settings command', e),
    },
    {
      label: 'Sprache ändern',
      icon: 'fa-regular fa-globe',
      items: [
        { label: 'Deutsch', action: { type: 'SET_LANGUAGE', data: 'de' } },
        { label: 'Englisch', action: { type: 'SET_LANGUAGE', data: 'en' } },
      ],
    },
    { separator: true },
    {
      label: 'Ausloggen',
      icon: 'fa-regular fa-arrow-right-from-bracket',
      command: () => {
        localStorage.clear();
        this.#router.navigateByUrl('/auth/login');
      },
    },
  ];

  homeCrumb = input<MenuItem>({ icon: 'fa-regular fa-house', routerLink: '/' });

  breadCrumbs = model<MenuItem[]>([]);

  /**
   * Template of the TopBar Logo.
   * @group Templates
   **/
  @ContentChild('logo') logoTemplate: TemplateRef<unknown> | null = null;
  logoSrc = input<string | null>(null);
  @ContentChild('toolbar') toolbarTemplate: TemplateRef<unknown> | null = null;

  @ContentChild('footer') footerTemplate: TemplateRef<unknown> | null = null;
  footerText = input<string | null>(null);

  @ContentChild('sidebarHeader')
  sidebarHeaderTemplate: TemplateRef<unknown> | null = null;

  @ContentChild('sidebarFooter')
  sidebarFooterTemplate: TemplateRef<unknown> | null = null;

  navItems = input<MenuItem[]>([]);
  sidebarEnabled = input<boolean>(true);
  showToggle = input<boolean>(true);
  sidebarVisible = signal<boolean>(true);

  routeActivated(outlet: RouterOutlet) {
    if (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData['breadcrumbs'] instanceof Array
    ) {
      this.breadCrumbs.set(outlet.activatedRouteData['breadcrumbs']);
    }
  }

  processAction(action: { type: string; data?: unknown } | void | string) {
    console.log(action);
  }
  toggleSidebar() {
    this.sidebarVisible.update((x) => !x);
  }
}
